<template>
  <Modal :value="true" :footer-hide="true" title="音乐欣赏" width="50%" @on-cancel="cancel">
    <div id="dplayer">
    </div>
  </Modal>
</template>
<script>
// import 'dplayer/dist/DPlayer.min.css'
import DPlayer from 'dplayer'
export default {
  name: 'VideoPlayer',
  data () {
    return {
      player: null
    }
  },
  mounted () {
    this.player = new DPlayer({
      container: document.getElementById('dplayer'),
      autoplay: false,
      theme: '#FADFA3',
      loop: true,
      lang: 'zh-cn',
      screenshot: true,
      hotkey: true,
      preload: 'auto',
      // logo: 'logo.png',
      volume: 0.7,
      mutex: true,
      video: {
        url: 'https://cdn.toxicjohann.com/lostStar.mp4',
        // pic: 'dplayer.png',
        // thumbnails: 'thumbnails.jpg',
        type: 'auto'
      },
      contextmenu: [
        {
          text: 'custom1',
          link: 'https://github.com/DIYgod/DPlayer'
        },
        {
          text: 'custom2',
          click: (player) => {
            console.log(player)
          }
        }
      ]
    })
  },
  methods: {
    cancel () {
      this.player.pause()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/components/video-player/index.vue